import { request } from './request';

export async function apiDelete(
    url: string,
    data?: any,
    options: { redirect?: boolean } = {}
) {
    return await request(url, data, 'DELETE', getNoRedirect(options));
}

export async function apiGet(
    url: string,
    data?: any,
    options: { redirect?: boolean } = {}
) {
    return await request(url, data, 'GET', getNoRedirect(options));
}

export async function apiPost(
    url: string,
    data?: any,
    options: { redirect?: boolean } = {}
) {
    return await request(url, data, 'POST', getNoRedirect(options));
}

export async function apiPut(
    url: string,
    data?: any,
    options: { redirect?: boolean } = {}
) {
    return await request(url, data, 'PUT', getNoRedirect(options));
}

function getNoRedirect({ redirect }: { redirect?: boolean }): boolean {
    return redirect === true ? false : true;
}
